import { array } from 'fp-ts';
import { pipe } from 'fp-ts/function';
import { useMemo } from 'react';
import { EnumSelectField, SelectField } from '@mews-commander/form';
import { FormTextareaField, lt } from '@mews/framework';
import { AccountNoteCustomerClassifications } from '@mews-commander/data-access';
import { Option } from '@mews-commander/types';
import { createOption } from '@mews-commander/ui';
import { fieldNames } from '../schema';
import { AccountName } from '../../../../../../../../../components';
import { AddNoteDialogContentProps } from './AddNoteDialogContent';

type AddGuestNoteFieldsProps = Pick<AddNoteDialogContentProps, 'accountsRecord'>;

export const AddGuestNoteFields = ({ accountsRecord }: AddGuestNoteFieldsProps) => {
    const accountsOptions: Array<Option> = useMemo(
        () =>
            pipe(
                accountsRecord,
                Object.values,
                array.map((account) => createOption({ value: account.id, label: <AccountName account={account} /> }))
            ),
        [accountsRecord]
    );

    return (
        <>
            <SelectField
                label={lt('GuestInHouseReportAddNoteAssignedGuestField')}
                name={fieldNames.accountId}
                options={accountsOptions}
                required
            />
            <EnumSelectField
                label={lt('Classification')}
                name={fieldNames.classification}
                enumClass={AccountNoteCustomerClassifications}
                enumPrefix="AccountNoteCustomerClassifications"
                required
            />
            <FormTextareaField
                label={lt('Content')}
                name={fieldNames.content}
                required
                rows={1}
                placeholder={lt('GuestInHouseReportAddNoteContentFieldPlaceholder')}
                size="small"
                autosize
            />
        </>
    );
};
